import { type App } from 'vue';
import { usePage }  from "@inertiajs/vue3";

/**
 * @global
 * @function asset
 * @param pathToImage {string}
 */
export const asset = (pathToImage : string) : string => {
    let version = '';

    if (pathToImage.startsWith('image/')) {
        version = '?v=' + usePage().props.version;
    }

    return usePage().props.base_url + 'storage/' + pathToImage + version;
};

export default {
    install(app : App) : void {
        app.config.globalProperties.asset = asset;
    },
};
